import { createConsumer } from '@rails/actioncable'
import type { ConversationListItem, Message, MessageTranslation } from '@/types/serializers'

// Create the ActionCable consumer
// In development, this connects to ws://localhost:5300/cable
// In production, it uses the same origin
export const cable = createConsumer()

// Re-export types for convenience
export type { ConversationListItem, Message, MessageTranslation }

export type InboxMessage =
  | { type: 'new_conversation'; conversation: ConversationListItem }
  | { type: 'conversation_updated'; conversation: ConversationListItem }
  | { type: 'team_status_changed'; user: TeamMemberStatus }

export interface TeamMemberStatus {
  id: string
  name: string
  online_status: 'online' | 'away' | 'offline'
  avatar_url: string | null
}

export type ConversationMessage =
  | { type: 'new_message'; message: Message }
  | { type: 'typing'; sender: { type: string; name: string }; is_typing: boolean }
